import tw from 'twin.macro';

import { IOrganizationTableUser } from '@account_module/types/Organizations';
import { USER_STATUS_KEY } from '@account_module/constants/userKeys';

const StatusLabel = tw.div`px-[8px] py-[4px] w-auto inline rounded-[4px]`;

export const StatusCell = ({
  item,
  t,
}: {
  item: keyof IOrganizationTableUser;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  t?: any;
}): JSX.Element => {
  const LABEL_STYLE_MAPER = {
    [USER_STATUS_KEY.activated]: tw`text-success-text-and-icon bg-success-bg`,
    [USER_STATUS_KEY.expired]: tw`text-error-text-icon bg-error-bg`,
    [USER_STATUS_KEY.invited]: tw`text-text-and-icon-muted-2 bg-sec-1`,
  };

  const STATUS_COPY_MAPPER = {
    [USER_STATUS_KEY.activated]: t(
      'account_module.settings_page.users_table.user_status.activated'
    ),
    [USER_STATUS_KEY.expired]: t('account_module.settings_page.users_table.user_status.expired'),
    [USER_STATUS_KEY.invited]: t('account_module.settings_page.users_table.user_status.invited'),
  };

  return (
    <div>
      <StatusLabel css={[LABEL_STYLE_MAPER[item]]}>{STATUS_COPY_MAPPER[item]}</StatusLabel>
    </div>
  );
};
